import React, { Component } from "react";

class Updates extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div className="text-left mt-4">
        <h1>Updates and fixes</h1>
        <small>
          <div className="text-secondary">
            <h5>August 25, 2020</h5>
            <ul>
              <li>Changed Collections interface</li>
              <li>
                Added "quick send" for each collection. This allows you to quickly
                send a set to an individual email.
              </li>
              <li>
                Added quick send of a monthly set. This will send the sets for
                that month to the emails which has the same tiers with the
                collection.
              </li>
            </ul>
            <h5>August 15, 2020</h5>
            <ul>
              <li>Fixed previous/next buttons when viewing photos in a set.</li>
            </ul>
            <h5>August 10, 2020</h5>
            <ul>
              <li>
                Fixed thumbs not able to be clicked when the filename is too
                long
              </li>
              <li>Shorten names in collections when they're too long</li>
              <li>Added updates page</li>
              <li>Added twitter link on the footer</li>
            </ul>
          </div>
        </small>
      </div>
    );
  }
}

export default Updates;
